import useIsPublicRoute from './useIsPublicRoute';
import appState from '@appState';
import { useNavigate, useRouter, useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';

export default function useRestoreLocation() {
  const router = useRouter();
  const { locationId } = useSearch({ strict: false });
  const navigate = useNavigate();
  const isPublicRoute = useIsPublicRoute();

  useEffect(() => {
    const lastLocationId = isPublicRoute ? undefined : appState.get().lastLocationId;

    if (locationId === undefined && lastLocationId) {
      navigate({ to: '.', search: { locationId: lastLocationId ?? '' }, hash: true });
    }

    return router.subscribe('onBeforeLoad', (state) => {
      appState.set('lastLocationId', (state.toLocation.search as { locationId?: string }).locationId || undefined);
    });
    // oxlint-disable-next-line exhaustive-deps
  }, []);
}
